'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TableColumn=require('../../../../dist-es6/client/directives/sortableTableDirective/tableColumn');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const DefaultDebounceRate=150;
const AvailableMatchTypes=['and','or'];
const DefaultMatchType=AvailableMatchTypes[1];let

SearchDirective=class SearchDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['data','searchableProperties','filteredData','currentFilter','lastUpdateTime','debounceRate','orSeparator','onMatchTransform','searchInputFocused','summary'];
}

get textBindings(){
return['placeholderText','matchType'];
}

get templateUrl(){
return'/templates/directives/searchDirective/searchTemplate';
}

get controller(){
return SearchDirectiveController;
}};let


SearchDirectiveController=class SearchDirectiveController{
static get $inject(){
return['$scope','$timeout'];
}

constructor($scope,$timeout){
this._$timeout=$timeout;
this.debounceRate=this.debounceRate||DefaultDebounceRate;

if(!_.exists(this.currentFilter)){
this._currentFilter='';
}

this.searchableProperties=this.searchableProperties||_.keys(this.data[0]);
this.matchType=this.matchType||DefaultMatchType;
this.searchInputFocused=!1;

if(!AvailableMatchTypes.includes(this.matchType)){
throw new Error(`[SearchDirective]: matchType "${this.matchType}" is not supported, must be one of available match types: ${AvailableMatchTypes}`);
}

this.orSeparatorRegex=_.exists(this.orSeparator)?
this.orSeparator instanceof RegExp?
this.orSeparator:
new RegExp(`\s+${this.orSeparator}\s+`,'gi'):
/\s+or\s+/gi;

this._performUpdate="production"==='test'?
()=>this._updateFilteredData():
_.debounce(()=>this._updateFilteredData(),this.debounceRate);

$scope.$watchGroup([
'controller.data',
'controller.searchableProperties',
'controller.currentFilter'],
()=>this._performUpdate());

this.currentPlaceholderText=this.placeholderText=this.placeholderText||'Search';
}

_updateSearchData(){
const len=this.data.length;
const searchData=new Array(len);
for(let i=0;i<len;i++){
searchData[i]=_.at(this.data[i],this.searchableProperties).join('!');
}

this._sourceDataForSearch=this.data;
this._sourcePropertiesForSearch=this.searchableProperties;
this._searchData=searchData;
}

_setData(data){
if(_.exists(data)&&_.isEqual(this._filteredData,data)){
return;
}


const summary=this.data?{found:data.length,total:this.data.length}:void 0;

this._$timeout(()=>{
this._summary=summary;
this._filteredData=data;
this._attachMethodsForMaterialOnDemand(this._filteredData);
this.lastUpdateTime=Date.now();
});
}

_attachMethodsForMaterialOnDemand(arr){
if(!arr){
return;
}

arr.getItemAtIndex=index=>arr[index];
const len=arr.length;
arr.getLength=()=>len;
}

_updateFilteredData(){
const currentFilter=_.toString(this._currentFilter).trim();
if(!currentFilter){
this._setData(this.data);
return;
}

if(this._sourceDataForSearch!==this.data||this._sourcePropertiesForSearch!==this.searchableProperties){
if(!this.data){
return;
}
this._updateSearchData();
}

const words=_.uniq(currentFilter.split(/\s+/g).map(s=>s.trim()).filter(s=>!!s));
const andMatcherRegex=new RegExp(words.map((word,i)=>`(?=.*\\b${_escapeRegExpCharactersAndOrSeparator(word,this.orSeparatorRegex)})`).join(''),'i');

const filterRegExp=new RegExp(_escapeRegExpCharactersAndOrSeparator(currentFilter,this.orSeparatorRegex),'i');
const lowerCaseFilter=currentFilter.toLowerCase();

const len=this._searchData.length;
const filteredData=new Array(len);

const _isMatch=this.matchType==='or'?
i=>this._searchData[i].toLowerCase().indexOf(lowerCaseFilter)!==-1||filterRegExp.test(this._searchData[i]):
i=>andMatcherRegex.test(this._searchData[i]);

const _addMatchResult=this.onMatchTransform?
i=>filteredData[i]=this.onMatchTransform(this._sourceDataForSearch[i],words,this._searchData[i].match(filterRegExp)):
i=>filteredData[i]=this._sourceDataForSearch[i];

for(let i=0;i<len;i++){
if(_isMatch(i)){
_addMatchResult(i);
}
}

this._setData(_.compact(filteredData));
}

get currentFilter(){
return this._currentFilter;
}

set currentFilter(currentFilter){
if(this._currentFilter===currentFilter){
return;
}

this._currentFilter=currentFilter;
}

set filteredData(value){

}

get filteredData(){
return this._filteredData;
}

get tableColumns(){
return this._tableColumns;
}

get summary(){
return this._summary;
}

set summary(nope){

}};


function _escapeRegExpCharactersAndOrSeparator(value,orSeparatorRegex){
return _.escapeRegExp(value).replace(orSeparatorRegex,'|');
}

module.exports=SearchDirective;
module.exports.controller=SearchDirectiveController;
//# sourceMappingURL=searchDirective.js.map
